import VisibleLoading from '@/components/utilities/VisibleLoading';
import GlossaryCategoryTag from './GlossaryCategoryTag';

const GlossaryHero = ({ title, perex, categories = [], eyebrow = 'Slovník pojmů' }) => {
  return (
    <header className="border-grey-200 border-b pt-14 pb-16">
      <VisibleLoading delay={75}>
        {({ ref, className }) => (
          <span
            ref={ref}
            className={`text-brand-500 mb-4 inline-block text-xs font-semibold tracking-[0.08em] uppercase ${className || ''}`.trim()}
          >
            {eyebrow}
          </span>
        )}
      </VisibleLoading>

      <VisibleLoading delay={100}>
        {({ ref, className }) => (
          <h1 ref={ref} className={`text-grey-950 mb-6 max-w-[760px] ${className || ''}`.trim()}>
            {title}
          </h1>
        )}
      </VisibleLoading>

      {perex && (
        <VisibleLoading delay={150}>
          {({ ref, className }) => (
            <p ref={ref} className={`text-grey-700 max-w-[680px] text-lg leading-relaxed ${className || ''}`.trim()}>
              {perex}
            </p>
          )}
        </VisibleLoading>
      )}

      {categories.length > 0 && (
        <VisibleLoading delay={200}>
          {({ ref, className }) => (
            <div ref={ref} className={`mt-6 flex flex-wrap gap-2 ${className || ''}`.trim()}>
              {categories.map((category) => (
                <GlossaryCategoryTag key={category.id} name={category.name} color={category.color} />
              ))}
            </div>
          )}
        </VisibleLoading>
      )}
    </header>
  );
};

export default GlossaryHero;
